module.exports = __webpack_public_path__ + "img/25.8ee062d9.jpg";